import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { FdFieldConfigs } from 'src/app/shared/fd-form-components/fd-form-components.module';
import { Messages } from 'src/app/shared/messages/messages';
import { DialogService } from 'src/app/shared/service/dialog.service';
import { ErrorService } from 'src/app/shared/service/error.service';
import { LoadingService } from 'src/app/shared/service/loading.service';
import { PfacModel, UpdatePfacModel } from '../../models/configuration-pfac.models';
import { ConfigurationPfacService } from '../../services/configuration-pfac.service';

@Component({
  selector: 'app-edit-pfac',
  templateUrl: './edit-pfac.component.html',
  styleUrl: './edit-pfac.component.scss',
  standalone: false
})
export class EditPfacComponent implements OnInit {

  formGroup: UntypedFormGroup;
  fields: FdFieldConfigs;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private configurationPfacService: ConfigurationPfacService,
    private errorService: ErrorService,
    private dialogService: DialogService,
    public loadingService: LoadingService,
    public dialogRef: MatDialogRef<EditPfacComponent>,
    @Inject(MAT_DIALOG_DATA) public pfac: PfacModel
  ) {}

  ngOnInit() {
    this.formGroup = this.createFormGroup();
    this.fields = this.createFields();
  }

  protected createFormGroup() {
    return this.formBuilder.group({
      cnpj: [{value: this.pfac?.cnpj || '', disabled: true}],
      name: [this.pfac?.name || '', Validators.required],
    });
  }

  createFields(): FdFieldConfigs {
    return {
      cnpj: {
        label: 'CNPJ',
        controlName: 'cnpj',
        disabled: true
      },
      name: {
        label: 'Nome',
        controlName: 'name',
        maxLength: 200,
        messages: {
          required: 'Informe o nome'
        }
      }
    };
  }

  save() {
    if (!this.formGroup.valid) {
      return;
    }

    const data = new UpdatePfacModel();
    data.name = this.formGroup.value.name || null;
    data.active = this.pfac.active;

    this.loadingService.show();
    this.configurationPfacService.update(this.pfac.id, data)
      .pipe(finalize(() => this.loadingService.hide()))
      .subscribe(() => {
        this.dialogService.openDialog(Messages.EDIT_SAVE_SUCCESS, () => this.close(true));
      }, (err: HttpErrorResponse) => {
        this.errorService.handleXHRError(err, Messages.EDIT_SAVE_ERROR);
      });
  }

  close(updated: boolean = false) {
    this.dialogRef.close(updated);
  }

}
